import React from 'react';
import Input from '../../ui/inputs/inputs';
import TextArea from '../../ui/textArea/textArea';
import Checkbox from '../../ui/checkbox/checkbox';
import Dropdown from '../../ui/dropdown/dropdown';
import PhoneInput from '../../ui/phone/phoneInput';
import SeparationTitle from '../../ui/separationTitle/separationTitle';
import { TYPES } from '../../../neoInput';
import UploadInput from "../upload/uploadInput";
import CountrySelector from "../../ui/country/countrySelector";
import {BirthdatePicker, DateCustomInput} from "../../ui/date-picker/datePicker";
import AddressAutocomplete from '../../ui/addressAutocomplete/addressAutocomplete';
import { parsedHTML } from '../../../resale/buyer/components/utils';
import {conditionnalConfig} from "../../../../utils/useForm";
import { useTranslation } from 'react-i18next';
import './form.css';

const FIELD = {
    textfield: Input,
    textarea: TextArea,
    checkbox: Checkbox,
    select: Dropdown,
    divider: SeparationTitle,
    file: UploadInput,
    phone: PhoneInput,
    birthdate: BirthdatePicker,
    country: CountrySelector,
    date: DateCustomInput,
    address_autocomplete: AddressAutocomplete,
    latitude_longitude: Input
    // image: UploadInput,
    // title: Dropdown,
};

function FormInput({type, subtype, label, choices, placeholder, required, onChange, currentValue, errors = null, country = null, fieldId, ...rest}) {
    const { i18n } = useTranslation();
    const InputComponent = React.useMemo(() => {
        if (subtype === 'phone' || subtype === 'address_autocomplete') {
            return FIELD[subtype];
        }
        if (type === 'birthdate' && fieldId !== 'ws-16') {
            return FIELD['date'];
        }
        return FIELD[type];
    }, [subtype, type]);

    const optionsSelect = React.useMemo(() => {
        if (type === "select") return choices?.map(choice => {return { key: choice.weez_id, label: choice.label, value: choice.weez_id, order: choice.order || undefined }});
        return undefined;
	}, [type, choices]);

    const castType = React.useCallback((value) => {
        let returnType = TYPES[type];
        if (returnType) {
            let val = returnType(value);
            if(val !== undefined && (!isNaN(val) || typeof val === 'string')){
                value = val;
            }
        }
        return value;
    }, []);

    const _onChange = React.useCallback((val) => {
        let value = val;
        if(val?.target){
            value = val.target.value;
        }

        // Handle checkbox cases
        if(val?.target?.type === 'checkbox') {
            value = val.target.checked ? 1 : 0;
        }

        value = [null, undefined].includes(value) ? value : castType(value);
        onChange(value);
    }, [onChange, castType]);

    if (!InputComponent) {
        return null;
    }

    if (['birthdate', 'date'].includes(type))  {
        rest.locale = i18n.language;
        rest.inputFormat = 'DD/MM/YYYY';
        rest.outputFormat = 'DD/MM/YYYY';
        if (currentValue === '--/--/----') {
            currentValue = ''
        }
    }

    if (['phone', 'country'].includes(type))
        rest.country = country;

    if (type === 'checkbox')  {
        rest.checked = Number(currentValue);
    }



    return (
        <InputComponent
            label={label}
            placeholder={placeholder}
            onChange={_onChange}
            type={type}
            subtype={subtype}
            options={optionsSelect}
            value={currentValue}
            required={required}
            errors={errors}
            fieldId={fieldId}
            {...rest}
        />
    )
}

const useIdForAddressAutoComplete = [
    'ws-28',//city
    'ws-29',//country
    'ws-27',//postal code
    'ws-8'//address
]

const autoCompleteMapping = {
'ws-2': 'family-name',
'ws-3': 'given-name',
'ws-16': 'on', // text input so bday not compatible
'ws-6': 'tel',
'ws-5': 'email',
'ws-27': 'postal-code',
'ws-28': 'address-level2',//city
'ws-8': 'street-address',//address
}

export default function Form({ fields, form, setFormValue, setFormObject = null, formIndex = '', formErrors = {}, country = null }) {
    // Render form
    let _fields = fields.map(({key, label, placeholder, type, subtype, value='', default_value= '', description, choices=[], conditional_display={}, required=false, disabled = false, allow_modification = true, props={}, ...rest }) => {
        // only include some props depending on field type
        if (useIdForAddressAutoComplete.includes(key))
            rest.id = `field_${formIndex}_${key}`;
        if (type === 'latitude_longitude')
            rest.id = `field_${formIndex}_${type}_${key}`; // we add `latitude_longitude` to the id cause the key isn't enough to distinct for selector
        if (type === 'address_autocomplete' || subtype ===  'address_autocomplete') {
            if (subtype === 'address_autocomplete')
                rest.api = 'google';
            rest.formObject = form;
            rest.setFormObject = setFormObject;
        }

        if (Object.keys(autoCompleteMapping).includes(key))
            rest.autoComplete = autoCompleteMapping[key];

        return <FormInput
            key={`${formIndex}_${key}`}
            uniqueKey={`${formIndex}_${key}`}
            fieldId={key}
            type={type}
            subtype={subtype}
            label={label}
            placeholder={placeholder}
            onChange={(value) => setFormValue(key, value)}
            description={description ? parsedHTML(description) : ''}
            currentValue={form[key]}
            choices={choices}
            errors={formErrors[key]}
            default_value={default_value}
            display={conditional_display?.display ? conditionnalConfig(conditional_display.display, form) : true}
            required={conditional_display?.required ? conditionnalConfig(conditional_display.required, form) : required}
            country={country}
            disabled={disabled || !allow_modification}
            {...props}
            {...rest}
        />
    });
    return (
        <>{_fields}</>
    )

}